<template>
  <div class="dialog-user-edit">
    <Form :model="roleMsg" :label-width="100" ref="editRoleForm">
      <FormItem label="角色名称：" prop="roleName" :rules="{required: true, message: '角色名称不能为空', trigger: 'blur'}">
        <Input v-model="roleMsg.roleName" :autofocus="true" placeholder="请输入角色名称"></Input>
      </FormItem>
      <FormItem label="账号类型：" prop="accountType" :rules="{required: true, message: '账号类型不能为空', trigger: 'blur'}">
        <Select v-model="roleMsg.accountType" :disabled="!!query">
          <Option value="1">管理员</Option>
          <Option value="2">客服</Option>
          <Option value="3">一级送审单位</Option>
          <Option value="4">二级送审单位</Option>
          <Option value="5">专家</Option>
          <Option value="6">接收单位</Option>
          <Option value="7">财务</Option>
        </Select>
      </FormItem>
      <FormItem label="备注：" prop="remark">
        <Input v-model="roleMsg.remark" placeholder="请输入备注"></Input>
      </FormItem>
      <FormItem label="菜单权限：" prop="menuIdList">
        <Tree ref="menuTree"
              style="max-height: 300px; overflow: auto;"
              :data="menuTreeData"
              show-checkbox
              multiple
              @on-select-change="selectTreeItem"
              @on-check-change="checkTreeItem"
        ></Tree>
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="formLoading"></Spin>
  </div>
</template>

<script>
export default {
  props: {
    query: '' // menu id
  },
  data () {
    return {
      roleMsg: { // form表单的属性值
        roleName: '',
        remark: '',
        menuIdList: []
      },
      defaultRole: {},
      menuTreeData: [],
      formLoading: true // 表单的loading状态
    }
  },
  created () {
    if (this.query) {
      this.fetchRoleMsg();
    } else {
      this.formLoading = false;
      this.fetchAllMenu();
    }
  },
  methods: {
    /**
     * 获取role的详细信息
     */
    fetchRoleMsg () {
      const _self = this;
      _self.fetch('/sys/role/info/' + _self.query).then(res => {
        _self.roleMsg = res.data;
        _self.defaultRole = JSON.parse(JSON.stringify(res.data));
        _self.formLoading = false;
        _self.fetchAllMenu();
      });
    },
    /**
     * 获取带层级的menu列表
     */
    fetchAllMenu () {
      const _self = this;
      _self.fetch('/sys/menu/menuTree').then(res => {
        let result = res.data;
        for (let menu of result) {
          let rootMenu = {
            id: menu.menuId,
            title: menu.name,
            selected: this.roleMsg.menuIdList.includes(menu.menuId)
          };
          if (menu.list && menu.list.length > 0) {
            // rootMenu.expand = true;
            // 默认不打开
            rootMenu.children = [];
            for (let child of menu.list) {
              let childMenu = {
                id: child.menuId,
                title: child.name,
                selected: this.roleMsg.menuIdList.includes(child.menuId)
              }
              if (child.list && child.list.length > 0) {
                // childMenu.expand = true;
                // 默认不打开
                childMenu.children = [];
                for (let lastChild of child.list) {
                  childMenu.children.push({
                    id: lastChild.menuId,
                    title: lastChild.name,
                    checked: this.roleMsg.menuIdList.includes(lastChild.menuId),
                    selected: this.roleMsg.menuIdList.includes(lastChild.menuId)
                  })
                }
              } else {
                childMenu.checked = this.roleMsg.menuIdList.includes(child.menuId)
              }
              rootMenu.children.push(childMenu);
            }
          } else {
            rootMenu.checked = this.roleMsg.menuIdList.includes(menu.menuId);
          }
          this.menuTreeData.push(rootMenu);
        }
      });
    },
    /**
     * 点击树节点的多选框
     **/
    checkTreeItem (selectItems, curItem) {
      curItem.selected = curItem.checked;
      if (curItem.children && curItem.children.length > 0) {
        for (let item of curItem.children) {
          item.checked = curItem.checked;
          this.checkTreeItem(selectItems, item);
        }
      }
    },
    /**
     * 点击树节点
     **/
    selectTreeItem (selectItems, curItem) {
      curItem.checked = curItem.selected;
      if (curItem.children && curItem.children.length > 0) {
        for (let item of curItem.children) {
          item.selected = curItem.selected;
          this.selectTreeItem(selectItems, item);
        }
      }
    },
    /**
     * 对比两个对象，将obj2中与obj1不同的全部抛出
     * @param obj1 default
     * @param obj2 change
     */
    compare (obj1, obj2) {
      let diff = {};
      for (let key of Object.keys(obj2)) {
        if ((obj1[key] + '') !== (obj2[key] + '')) {
          diff[key] = obj2[key];
        }
      }
      return diff;
    },
    /**
     * 框架弹窗确认时被调用，必须方法
     * @returns {Promise<any>}
     */
    dialogComfirm () {
      const _self = this;
      return new Promise((resolve, reject) => {
        _self.$refs['editRoleForm'].validate((valid) => {
          if (valid) {
            let param = _self.compare(_self.defaultRole, _self.roleMsg);
            if (_self.defaultRole.roleId) {
              param.roleId = _self.defaultRole.roleId;
            }
            param.menuIdList = [];
            let menuPermission = _self.$refs['menuTree'].getCheckedAndIndeterminateNodes();
            for (let permission of menuPermission) {
              param.menuIdList.push(permission.id);
            }
            _self.post('/sys/role/saveOrUpdate', param).then(res => {
              resolve();
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/roleEdit.vue